import { useTranslation } from 'react-i18next';

import { useFinancials } from './editor';

import { DrawerBackButton } from '@/components/ui';

/**
 * The Financials drawer's collapse row: "Show project summary" while the panel
 * shows a contract, nothing in the overview — Planning's `PlanDrawerHeading`,
 * with a contract where Planning has a task (3 Nov, Mette).
 */
export const FinancialsDrawerHeading = () => {
  const { asideView, setAsideView } = useFinancials();
  const { t } = useTranslation('pmCommon');
  if (asideView === 'project') return null;
  return (
    <DrawerBackButton
      label={t('term.ShowProjectSummary')}
      onClick={() => setAsideView('project')}
      automationId="contract-aside-show-project"
    />
  );
};
